import { useUpdatePartnerDiscountModals } from "@/features/update-partner-discount"
import { useAppDispatch } from "@/shared/lib/redux"
import { fetchPartnerDiscounts } from "../../model"

export const CreateDiscount = () => {
    const { openCreateDiscountModal } = useUpdatePartnerDiscountModals()
    const dispatch = useAppDispatch()

    const onCreate = () => {
        dispatch(fetchPartnerDiscounts())
    }
    
    return (
        <button onClick={() => openCreateDiscountModal(onCreate)} className="filter_button !w-fit">
            Создать скидку
        </button>
    )
}